import React, { useEffect, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BiArrowBack, BiListUl } from 'react-icons/bi';
import { platformAPI } from '../../../services/platformAPI';
import WorkspacePageHeader from '../../../components/workspace/WorkspacePageHeader';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { canManageMasters } from '../../../utils/permissions';
import { settingsBase } from './settingsPaths';
import '../tender/MastersPage.scss';
import '../tender/CustomerMaster.scss';

const DropdownCatalogPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const base = settingsBase(location.pathname);
  const [catalogs, setCatalogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useDocumentTitle('Dropdown master');

  useEffect(() => {
    let cancelled = false;
    platformAPI.listDropdownCatalogs()
      .then((response) => {
        if (!cancelled) setCatalogs(response.data?.data?.catalogs || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.message || 'Unable to load dropdown lists.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (!canManageMasters(user?.permissions, user?.roles)) {
    return <Alert variant="warning">A tender administrator maintains dropdown lists.</Alert>;
  }

  return (
    <div className="mst-catalog">
      <button type="button" className="cust-page__back" onClick={() => navigate(base)}>
        <BiArrowBack />
        Settings
      </button>
      <WorkspacePageHeader
        title="Dropdown master"
        help="settings"
        subtitle="Each card is a list used on a form. Tender stages is the list shown when a tender is created or edited."
      />
      {error ? <Alert variant="danger">{error}</Alert> : null}
      {loading ? <Spinner animation="border" size="sm" /> : (
        <div className="mst-catalog__grid">
          {catalogs.map((catalog) => (
            <button
              key={catalog.key}
              type="button"
              className="mst-catalog__card"
              onClick={() => navigate(`${base}/dropdowns/${catalog.key}`)}
            >
              <div className="mst-catalog__card-head">
                <span className="mst-catalog__icon" aria-hidden>
                  <BiListUl />
                </span>
                <h2>{catalog.title}</h2>
              </div>
              <p>{catalog.description}</p>
              <p>{catalog.activeCount} active</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownCatalogPage;
